export const mealRoutes = [
  {
    path: '/dishes',
    component: () => import('@/views/dish/Dishes.vue'),
    name: 'dishes',
    meta: {
      title: 'Danh sách món ăn'
    }
  },
  {
    path: '/food-menu',
    component: () => import('@/views/foodMenu/FoodMenu.vue'),
    name: 'food-menu',
    meta: {
      title: 'Quản lý suất ăn'
    }
  },
  {
    path: '/student-menu-register',
    component: () => import('@/views/studentMenuRegister/StudentMenuRegister.vue'),
    name: 'student-menu-register',
    meta: {
      title: 'Danh sách đăng ký'
    }
  },
  {
    path: '/meal-report',
    component: () => import('@/views/mealReport/MealReport.vue'),
    name: 'meal-report',
    meta: {
      title: 'Báo cáo suất ăn'
    }
  }
]
